import ls from 'localstorage-slim';

export const PARTNER_STACK_ID_QUERY_STRING_KEY = 'ps_xid';
export const PARTNER_STACK_PARTNER_KEY_QUERY_STRING_KEY = 'ps_partner_key';
const STORAGE_KEY = 'ps_data';
const STORAGE_TTL_SECONDS = 60 * 60 * 24 * 1; // 1 day

export type PartnerStackStorage = {
  psId: string | null;
  psPartnerKey: string | null;
};

export class PartnerStackService {
  static getFromStorage = () => {
    return ls.get<PartnerStackStorage>(STORAGE_KEY);
  };

  static identify = (psId: string | null, psPartnerKey: string | null) => {
    if (psId === null && psPartnerKey === null) {
      return;
    }

    const payload: PartnerStackStorage = {
      psId,
      psPartnerKey,
    };

    ls.set<PartnerStackStorage>(STORAGE_KEY, payload, {
      ttl: STORAGE_TTL_SECONDS,
    });
  };

  static removeFromStorage = () => {
    ls.remove(STORAGE_KEY);
  };
}
